"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NODE_INFO = exports.NEW_DASHBOARD = exports.NEW_FORM_TEMPLATE = exports.NEW_FOLDER = exports.NEW_FORM = exports.NEW_DATASHEET = exports.NODE_IMPORT = exports.NODE_EXPORT = exports.FORM_USE_GUIDE_BTN = exports.OPERATE_ITEM_MOVE_TO = exports.OPERATE_ITEM_ADD_DATASHEET = exports.OPERATE_ITEM_DELETE_NODE = exports.OPERATE_ITEM_SAVE_AS_TEMPLATE = exports.OPERATE_ITEM_SHARE_NODE = exports.OPERATE_ITEM_SET_PERMISSIONS = exports.OPERATE_ITEM_EXPORT_NODE_EXCEL = exports.OPERATE_ITEM_EXPORT_NODE_CSV = exports.OPERATE_ITEM_COPY_NODE_URL = exports.OPERATE_ITEM_COPY_NODE = exports.OPERATE_ITEM_STAR_NODE = exports.OPERATE_ITEM_RENAME_NODE = exports.TO_SPACE_TEMPLATE = exports.RECYCLE_BIN = exports.ADD_NODE_BTN = exports.NODE_WRAPPER = void 0;
/* eslint_disable */
// workbench - working directory ID
const PREFIX = 'WORKBENCH_SIDE_';
// star and container for working directory
exports.NODE_WRAPPER = PREFIX + 'NODE_WRAPPER';
exports.ADD_NODE_BTN = PREFIX + 'ADD_NODE_BTN';
// recycle bin
exports.RECYCLE_BIN = PREFIX + 'RECYCLE_BIN';
// use template
exports.TO_SPACE_TEMPLATE = PREFIX + 'TO_SPACE_TEMPLATE';
// Action menu context of the working directory node
exports.OPERATE_ITEM_RENAME_NODE = PREFIX + 'RENAME_NODE';
exports.OPERATE_ITEM_STAR_NODE = PREFIX + 'STAR_NODE';
exports.OPERATE_ITEM_COPY_NODE = PREFIX + 'COPY_NODE';
exports.OPERATE_ITEM_COPY_NODE_URL = PREFIX + 'COPY_NODE_URL';
exports.OPERATE_ITEM_EXPORT_NODE_CSV = PREFIX + 'EXPORT_NODE_CSV';
exports.OPERATE_ITEM_EXPORT_NODE_EXCEL = PREFIX + 'EXPORT_NODE_EXCEL';
exports.OPERATE_ITEM_SET_PERMISSIONS = PREFIX + 'SET_PERMISSIONS';
exports.OPERATE_ITEM_SHARE_NODE = PREFIX + 'SHARE_NODE';
exports.OPERATE_ITEM_SAVE_AS_TEMPLATE = PREFIX + 'SAVE_AS_TEMPLATE';
exports.OPERATE_ITEM_DELETE_NODE = PREFIX + 'DELETE_NODE';
exports.OPERATE_ITEM_ADD_DATASHEET = PREFIX + 'ADD_DATASHEET';
exports.OPERATE_ITEM_MOVE_TO = PREFIX + 'MOVE_TO';
// collection table, form
exports.FORM_USE_GUIDE_BTN = PREFIX + 'FORM_USE_GUIDE_BTN';
exports.NODE_EXPORT = PREFIX + 'NODE_EXPORT';
exports.NODE_IMPORT = PREFIX + 'NODE_IMPORT';
exports.NEW_DATASHEET = PREFIX + 'NEW_DATASHEET';
exports.NEW_FORM = PREFIX + 'NEW_FORM';
exports.NEW_FOLDER = PREFIX + 'NEW_FOLDER';
exports.NEW_FORM_TEMPLATE = PREFIX + 'NEW_FORM_TEMPLATE';
exports.NEW_DASHBOARD = PREFIX + 'NEW_DASHBOARD';
exports.NODE_INFO = PREFIX + 'NODE_INFO';
//# sourceMappingURL=workbench_side_id.js.map